// Pincode Delivery Date Calculator
document.addEventListener('DOMContentLoaded', function() {
  // Pincode data will be loaded via the pincode-data.liquid snippet
  let pincodeData = [];
  let isDataLoaded = false;
  
  // Check if data is already available
  if (window.pincodeData && window.pincodeData.length > 0) {
    pincodeData = window.pincodeData;
    isDataLoaded = true;
    console.log('Pincode data already available:', pincodeData.length, 'entries');
    initPincodeChecker();
  } else {
    // Listen for the data loaded event
    document.addEventListener('pincodeDataLoaded', function(event) {
      pincodeData = event.detail;
      isDataLoaded = true;
      console.log('Pincode data received via event:', pincodeData.length, 'entries');
      initPincodeChecker();
    });
    
    // Also check periodically in case the event was missed
    const checkInterval = setInterval(() => {
      if (window.pincodeData && window.pincodeData.length > 0 && !isDataLoaded) {
        pincodeData = window.pincodeData;
        isDataLoaded = true;
        console.log('Pincode data found via polling:', pincodeData.length, 'entries');
        clearInterval(checkInterval);
        initPincodeChecker();
      }
    }, 100);
    
    // Stop checking after 5 seconds and use fallback
    setTimeout(() => {
      if (!isDataLoaded) {
        clearInterval(checkInterval);
        console.log('Timeout reached, using fallback data');
        pincodeData = [
          { "Pincode": 560068, "Standard Transit Days": 7, "Delivery Charge": 0 },
          { "Pincode": 560064, "Standard Transit Days": 10, "Delivery Charge": 0 },
          { "Pincode": "560068", "Standard Transit Days": 7, "Delivery Charge": 0 },
          { "Pincode": "560064", "Standard Transit Days": 10, "Delivery Charge": 0 }
        ];
        isDataLoaded = true;
        initPincodeChecker();
      }
    }, 5000);
  }

  function initPincodeChecker() {
    const pincodeContainers = document.querySelectorAll('.product__pincode-check');
    console.log('Initializing pincode checker with', pincodeData.length, 'entries');
    
    pincodeContainers.forEach(container => {
      const input = container.querySelector('.pincode-input');
      const button = container.querySelector('.pincode-button');
      const result = container.querySelector('.pincode-result');
      const header = container.querySelector('.pincode-check__header');
      
      if (!input || !button || !result) return;
      
      // Create "Check another pincode" link
      const checkAnother = document.createElement('a');
      checkAnother.textContent = 'Check another pincode';
      checkAnother.href = '#';
      checkAnother.className = 'check-another-link';
      checkAnother.style.display = 'none';
      if (header) header.appendChild(checkAnother);
      
      // Helper to reset form
      function resetForm() {
        input.style.display = '';
        button.style.display = '';
        if (checkAnother) checkAnother.style.display = 'none';
        input.value = '';
        result.textContent = '';
        input.focus();
      }
      
      checkAnother.addEventListener('click', function(e){
        e.preventDefault();
        resetForm();
      });
      
      // Check for existing pincode cookie and auto-check
      const savedPincode = getCookie('user_pincode');
      if (savedPincode) {
        console.log('Found saved pincode:', savedPincode);
        input.value = savedPincode;
        // Auto-check the saved pincode after a short delay
        setTimeout(() => {
          checkPincode(input, button, result, checkAnother, true);
        }, 500);
      }
      
      // Allow only numeric input and auto-check on 6 digits
      let autoTimeout;
      input.addEventListener('input', function() {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value.length === 6) {
          checkPincode(input, button, result, checkAnother);
        }
      });
      
      // Enable checking with Enter key
      input.addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          checkPincode(input, button, result, checkAnother);
        }
      });
      
      // Button click handler
      button.addEventListener('click', function() {
        checkPincode(input, button, result, checkAnother);
      });
    });
  }

  function checkPincode(input, button, result, checkAnother, isAutoCheck = false) {
    const pin = input.value.trim();
    
    // Validate pincode format (show reset link if invalid length)
    if (!pin || pin.length < 6) {
      result.textContent = 'Please enter a valid 6-digit pincode';
      result.style.color = '#cc0000';
      if (checkAnother) checkAnother.style.display = 'inline';
      return;
    }
    
    // Show loading state (but not for auto-checks)
    if (!isAutoCheck) {
      button.disabled = true;
      const originalButtonText = button.textContent;
      button.textContent = 'Checking...';
      result.textContent = 'Checking delivery date...';
    }
    
    console.log('Checking pincode:', pin, isAutoCheck ? '(auto-check)' : '(manual)');
    console.log('Available data entries:', pincodeData.length);
    
    // Find matching pincode in data (check both string and number formats)
    const entry = pincodeData.find(item => {
      const itemPincode = item.Pincode || item.CPINCODE;
      const matches = itemPincode == pin;
      if (matches) {
        console.log('Found match:', item);
      }
      return matches;
    });
    
    console.log('Entry found for', pin, ':', entry);
    
    const processResult = () => {
      if (entry) {
        const transitDays = parseInt(entry["Standard Transit Days"]);
        const productionDays = 7;
        const totalDays = transitDays + productionDays;
        const deliveryDate = getDeliveryDate(totalDays);
        
        // For auto-checks, show a different message
        const deliveryMessage = isAutoCheck ? 
          `<div class="delivery-result-single-line auto-check">
            <span class="delivery-date-left"><span class="delivery-check">✓</span> Estimated delivery by: <strong>${deliveryDate}</strong></span>
            <span class="cod-available-right"><span class="delivery-check">✓</span> COD Available</span>
          </div>` :
          `<div class="delivery-result-single-line">
            <span class="delivery-date-left"><span class="delivery-check">✓</span> Estimated delivery by: <strong>${deliveryDate}</strong></span>
            <span class="cod-available-right"><span class="delivery-check">✓</span> COD Available</span>
          </div>`;
        
        result.innerHTML = deliveryMessage;
        result.style.color = '';
        
        // Hide input/button and show result
        input.style.display = 'none';
        button.style.display = 'none';
        
        // Show the check another link in header
        if (checkAnother) checkAnother.style.display = 'inline-block';
        
        // Store cookies (extend expiry if it's a new check)
        if (!isAutoCheck) {
          setCookie('user_pincode', pin, 30);
          setCookie('user_location', pin, 30);
          console.log('Pincode saved to cookie for future visits');
        }
      } else {
        result.textContent = 'Delivery not available for this pincode';
        result.style.color = '#cc0000';
        if (checkAnother) checkAnother.style.display = 'inline';
        
        // Clear cookies if pincode is invalid
        setCookie('user_pincode', '', -1);
        setCookie('user_location', '', -1);
      }
      
      // Reset button state (only if it was a manual check)
      if (!isAutoCheck) {
        button.disabled = false;
        button.textContent = 'Check Delivery Date';
      }
    };
    
    // Add delay for manual checks, immediate for auto-checks
    if (isAutoCheck) {
      processResult();
    } else {
      setTimeout(processResult, 500);
    }
  }

  function getDeliveryDate(daysToAdd) {
    const date = new Date();
    date.setDate(date.getDate() + daysToAdd);
    
    const options = { year: 'numeric', month: 'long', day: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }

  // Cookie helper functions
  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }
  
  function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }
}); 